import {
    Component,
    Inject,
    Input,
    LOCALE_ID,
    TemplateRef,
    ViewChild,
    AfterContentInit,
    signal
} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { SettingsDrawerService, ThemeService } from '@nagel-services';
import { CommonModule, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { LookupField, BaseChangeEvent, Locale } from '@nagel-types';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { SettingsDrawerComponent } from '../settings-drawer/settings-drawer.component';
import { IconComponent } from '@nagel-assests';
import { LookupFieldComponent } from '@nagel-form';
import { supportedLocales } from '@nagel-consts';
import { TraceBadgeComponent } from '../trace-badge/trace-badge.component';

@Component({
    selector: 'lib-header',
    imports: [
        MatToolbarModule,
        IconComponent,
        MatButtonModule,
        NgOptimizedImage,
        CommonModule,
        NgTemplateOutlet,
        LookupFieldComponent,
        MatSidenavModule,
        SettingsDrawerComponent,
        TraceBadgeComponent
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements AfterContentInit {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() headerContent!: TemplateRef<any>;
    @Input() getProfilePicturePath!: (localeId: string) => string;
    @Input() showDebugTrace: boolean = false;
    @ViewChild('drawer') drawer: MatDrawer | undefined;
    profilePicturePath = signal<string>('/assets/profile_picture.webp');

    constructor(
        private themeService: ThemeService,
        @Inject(LOCALE_ID) private localeId: string,
        private settingsDrawerService: SettingsDrawerService
    ) {
    }

    ngAfterContentInit(): void {
        this.profilePicturePath.set(this.getProfilePicturePath(this.localeId));
    }

    private updateLocaleInRoutes = (event: BaseChangeEvent): void => {
        const selectedValue = event.value as string;
        const currentPath = window.location.href;
        const replaceLocaleRegex = new RegExp(`${this.supportedLocales.map(locale => locale.localeCode).join('|')}/`, 'g');
        const newPath = currentPath.replace(replaceLocaleRegex, `${selectedValue}/`);
        localStorage.setItem('locale', selectedValue);
        window.location.href = newPath;
    };

    supportedLocales: Locale[] = supportedLocales;

    toggleTheme(): void {
        this.themeService.toggleTheme();
    }

    getIconName(): string {
        return this.themeService.isDarkTheme() ? 'sun_icon' : 'moon_icon';
    }

    private languageOptions = this.supportedLocales.map(locale => {
        return {
            value: locale.localeCode,
            viewValue: locale.label
        };
    });


    selectedLocale = this.localeId || localStorage.getItem('locale') || 'en-US';

    languageSelectionField: LookupField = new LookupField({
        key: 'languageSwitch',
        label: '',
        value: this.selectedLocale,
        className: 'header-language-switch h-10 w-[120px]',
        readonly: false,
        options: this.languageOptions,
        onChange: this.updateLocaleInRoutes
    });

    toggleDrawer() {
        this.settingsDrawerService.toggleDrawer();
    }
}